import { getChosenCookies } from '@/helpers/getChosenCookies';

let MicrosoftAdsInitializationOnce = false;

export const MicrosoftAdsService = {
	initialization(callback?: () => void) {
		if (!MicrosoftAdsInitializationOnce) {
			MicrosoftAdsInitializationOnce = true;

			// Create unique ID for callback
			const callbackId = `microsoftAdsCallback_${Date.now()}_${Math.random()
				.toString(36)
				.substr(2, 9)}`;

			if (callback) {
				(window as any)[callbackId] = callback;
			}

			const script = document.createElement('script');
			script.type = 'text/javascript';
			script.async = true;

			script.onerror = () => {
				try {
					console.warn('⚠️ Microsoft Ads script failed to load');
					// Викликаємо callback навіть при помилці завантаження
					if (callback && (window as any)[callbackId]) {
						(window as any)[callbackId]();
						(window as any)[callbackId] = undefined;
					}
				} catch (e) {
					console.error('Microsoft Ads callback error:', e);
				}
			};

			script.text = `(function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){
				var o={ti:"343208338", enableAutoSpaTracking: true};
				o.q=w[u];
				try {
					if(typeof UET !== 'undefined') {
						w[u]=new UET(o);
					} else {
						console.warn('⚠️ UET is not defined');
					}
				} catch(e) {
					console.error('Microsoft Ads UET initialization error:', e);
				}
				w[u].push("pageLoad");
				try {
					if(typeof w['${callbackId}'] === 'function') {
						w['${callbackId}']();
						w['${callbackId}']=undefined;
					}
				} catch(e) {
					console.error('Microsoft Ads callback execution error:', e);
				}
			},
			n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){
				var s=this.readyState;
				s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null);
				try {
					if(typeof w['${callbackId}'] === 'function') {
						w['${callbackId}']();
						w['${callbackId}']=undefined;
					}
				} catch(e) {
					console.error('Microsoft Ads callback execution error:', e);
				}
			},
			n.onerror=function(){
				try {
					if(typeof w['${callbackId}'] === 'function') {
						w['${callbackId}']();
						w['${callbackId}']=undefined;
					}
				} catch(e) {
					console.error('Microsoft Ads callback execution error:', e);
				}
			},
			i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})
			(window,document,"script","//bat.bing.com/bat.js","uetq");`;

			document.body.appendChild(script);
		} else if (callback) {
			// If script is initialized, calling callback immediately
			try {
				callback();
			} catch (e) {
				console.error('Microsoft Ads callback error:', e);
			}
		}
	},

	logEvent(event: string, eventProperties?: object) {
		try {
			if (getChosenCookies('marketing') && (window as any).uetq) {
				(window as any).uetq.push('event', event, eventProperties);
			}
		} catch (e) {
			console.error('Microsoft Ads logEvent error:', e);
		}
	},

	remove() {
		try {
			if (MicrosoftAdsInitializationOnce) {
				// Remove all external Microsoft Ads scripts
				const bingScripts = document.querySelectorAll(
					'script[src*="bat.bing.com"]',
				);

				bingScripts.forEach(script => {
					script.remove();
				});

				// Remove inline script if it contains 'bat.bing.com/bat.js'
				document.querySelectorAll('script').forEach(script => {
					if (script.innerHTML.includes('bat.bing.com/bat.js')) {
						script.remove();
					}
				});

				// Remove Microsoft Ads tracking images from DOM
				const batElements = document.querySelectorAll('[id*="batBeacon"]');
				batElements.forEach(el => el.remove());

				// Remove the uetq function
				(window as any).uetq = undefined;
				MicrosoftAdsInitializationOnce = false;

				console.log('Microsoft Ads scripts removed');
			}
		} catch (e) {
			console.error('Microsoft Ads remove error:', e);
		}
	},
};
